import React, { useState } from 'react';

import { InputButton } from "../index.jsx"

const AddOption = props => {
    const [ value, setValue ] = useState()
    const [ error, setError ] = useState()

    const ucFirst = (string) =>
        string.charAt(0).toUpperCase() + string.slice(1)

    const onAddClick = () => {
        if (!value) {
            return setError('You must enter a value')
        }

        if (props.validate) {
            let result = props.validate(value)

            if (result) {
                return setError(result)
            }
        }

        props.onAdd(ucFirst(value))
        setValue("")
    }

    const onKeyDown = (e) => {
        if (e.key === 'Enter' && !props.noEnterSubmit) {
            e.preventDefault()
            onAddClick()
        }
    }

    const onChange = (e) => {
        setValue(e.target.value)
        setError(null)
    }

    return (
        <div className="add-option">
            {props.label && <label>{ props.label || "add new" }</label>}

            <div className="input">
                { props.type === 'textarea' && (
                    <textarea
                        placeholder={props.placeholder || "Type here"}
                        value={value}
                        onChange={onChange}
                        onKeyDown={onKeyDown}
                    />
                )}

                { props.type !== 'textarea' && (
                    <input
                        type="text"
                        placeholder={props.placeholder || "Type here"}
                        value={value}
                        onChange={onChange}
                        onKeyDown={onKeyDown}
                    />
                )}

                <InputButton onClick={onAddClick}>{props.addText}</InputButton>
            </div>

            { error && <div className="error">{error}</div>}
        </div>
    )
};

export default AddOption;